/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Appointment } from './Appointment'
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { Candidate } from './Candidate'
import type { CompanyUpdateEmailComponent } from './CompanyUpdateEmailComponent'
import type { Department } from './Department'
import type { GlobalAboutComponent } from './GlobalAboutComponent'
import type { GlobalAddressComponent } from './GlobalAddressComponent'
import type { GlobalEmbedComponent } from './GlobalEmbedComponent'
import type { GlobalMediaComponent } from './GlobalMediaComponent'
import type { Interaction } from './Interaction'
import type { Location } from './Location'
import type { Message } from './Message'
import type { Placement } from './Placement'
import type { ProfilingFilterTagComponent } from './ProfilingFilterTagComponent'
import type { ProfilingProfileComponent } from './ProfilingProfileComponent'
import type { Referral } from './Referral'
import type { Review } from './Review'
import type { Tag } from './Tag'
import type { Talentpool } from './Talentpool'
import type { UploadFile } from './UploadFile'
import type { Users_Permissions_User } from './Users_Permissions_User'
import type { Vacancy } from './Vacancy'
export type Company = {
  id?: number
  status: Company.status
  name: string
  slug?: string
  logo?: UploadFile
  about?: GlobalAboutComponent
  address?: GlobalAddressComponent
  highlights?: GlobalMediaComponent
  embeds?: Array<GlobalEmbedComponent>
  verified?: boolean
  departments?: Array<Department>
  tags?: Array<Tag>
  users?: Array<Users_Permissions_User>
  vacancies?: Array<Vacancy>
  locations?: Array<Location>
  reviews?: Array<Review>
  lastAddressStatus?: string
  interactions?: Array<Interaction>
  profile?: ProfilingProfileComponent
  lastUpdateEmail?: CompanyUpdateEmailComponent
  appointments?: Array<Appointment>
  placements?: Array<Placement>
  tokens?: number
  candidates?: Array<Candidate>
  BusinessIntelligence?: BusinessIntelligenceBiReportingComponent
  media?: Array<UploadFile>
  filterTags?: Array<ProfilingFilterTagComponent>
  finishedOnboarding?: boolean
  messages?: Array<Message>
  hasPremium?: boolean
  talentpools?: Array<Talentpool>
  referrals?: Array<Referral>
  sentReferrals?: Array<Referral>
  disableGeoFilter?: boolean
  autoInteract?: boolean
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Company {
  export enum status {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
  }
}
